import React, {useEffect} from 'react';
import SearchBar from "../components/SearchBar";
import {useNavigate} from "react-router-dom";
import Slideshow from "../components/Slideshow";

import Navbar from "../../../layouts/Navbar";
import Alerts from "../components/Alerts";
import OrganizationPropertise from "../components/OrganizationPropertise";
import ServiceGroups from "../components/ServiceGroups";
import Services from "../components/Services";
const HomePage = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;

    useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

            if(token) {
                if(window.localStorage.getItem("needRegistration") === '1'){
                    navigate('/register');
                }
            }
            else {
                if(config.service_app_settings.need_login > 0 ) {
                    navigate('/login');
                }
            }

    }, []);

    return (
        <div className='pt-md-4'>
            <Alerts/>
            <SearchBar />
            <Slideshow />
            <Services />

            <OrganizationPropertise />
            <Navbar/>
        </div>
    );
};

export default HomePage;